module.exports = __webpack_public_path__ + "img/tz.379f0c73.png";